import { Component, inject } from '@angular/core'

import { BaseDialogComponent } from '@hyperkit'

import { SupportService } from '../../../services/support.service'

@Component({
  standalone: false,
  selector: 'premium-dialog',
  templateUrl: './premium-dialog.component.html',
  styleUrls: ['./premium-dialog.component.scss'],
})
export class PremiumDialogComponent extends BaseDialogComponent<
  unknown,
  boolean
> {
  supportService = inject(SupportService)

  public submitted = false
  public error: string
  public isSmallScreen = false

  public talkToCyborg(): void {
    this.dialogRef.close(true)
  }

  public onClose(): void {
    this.dialogRef.close()
  }

  protected initializeOptions(): void {
    this.options = { headerText: 'Premium' }
  }
}
